import {
  OrganizationService,
  OrganizationsFindAllPayload,
} from "../services/organizations.service";
import { OrganizationPayload } from "../domain/organizations.interface";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useOrganizationUnitsByIds = ({
  ids,
  status,
}: {
  ids: string[];
  status: string;
}) => {
  const {
    data: organizationUnits,
    isLoading: isLoadingOrganizationUnits,
    refetch: refetchOrganizationUnits,
  } = useQuery({
    queryKey: ["parca-organization-units", ids],
    queryFn: () =>
      OrganizationService.findByIds({
        ids,
        status,
      }),
    enabled: ids.length > 0,
  });

  return {
    organizationUnits,
    isLoadingOrganizationUnits,
    refetchOrganizationUnits,
  };
};

export const useOrganizations = (filters: OrganizationsFindAllPayload) => {
  const {
    data: organizations,
    isLoading: isLoadingOrganizations,
    isFetching: isFetchingOrganizations,
    refetch: refetchOrganizations,
  } = useQuery({
    queryKey: ["parca-organizations-list"],
    queryFn: () => OrganizationService.findAll(filters),
  });

  return {
    organizations,
    isLoadingOrganizations,
    isFetchingOrganizations,
    refetchOrganizations,
  };
};

export const useOrganizationsCatalog = (enabled = true) => {
  const {
    data: organizationsCatalog,
    isLoading: isLoadingOrganizationsCatalog,
    refetch: refetchOrganizationsCatalog,
  } = useQuery({
    queryKey: ["parca-organizations-catalog"],
    queryFn: () => OrganizationService.findActive(),
    enabled,
  });

  return {
    organizationsCatalog,
    isLoadingOrganizationsCatalog,
    refetchOrganizationsCatalog,
  };
};

export const useCreateOrganization = () => {
  return useMutation({
    mutationFn: (payload: OrganizationPayload) =>
      OrganizationService.createOne(payload),
  });
};

export const useUpdateOrganization = () => {
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: OrganizationPayload;
    }) => OrganizationService.updateOne({ id, payload }),
  });
};

export const useArchiveOrganization = () => {
  return useMutation({
    mutationFn: (id: string) => OrganizationService.archiveOne(id),
  });
};
